import { Component, computed, inject } from '@angular/core';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from 'core/services/auth.service';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';
import { ReferralModalFacade } from '../../../shared/services/referral-modal.facade';
import { RouterLink } from '@angular/router';
import { NavigationService } from 'core/services/navigation.service';

@Component({
  selector: 'app-empty',
  imports: [GoBackComponent, TranslatePipe, KorviuButtonComponent, RouterLink],
  templateUrl: './empty.component.html',
  styleUrl: './empty.component.scss'
})
export class EmptyComponent {
  readonly authService = inject(AuthService);
  readonly referralModalFacade = inject(ReferralModalFacade);
  private readonly navigationService = inject(NavigationService);

  readonly currentUser = computed(() => this.authService.currentUser$());
  readonly leavesNumber = computed<number>(() => this.currentUser()?.leaves ?? 0);
  readonly referrals = computed<number>(() => this.currentUser()?.totalReferrals ?? 0);
  readonly community = computed<number>(() => this.currentUser()?.totalNetworkSize ?? 0);

  onPlantSeed(): void {
    this.referralModalFacade.openAddReferralModal();
  }

  onWatchSeeds(): void {
    this.navigationService.setNextGoBackUrl('/workspace/my-forest');
  }
}
